import { PrinterOptionsSchema } from "@redotech/redo-fulfillment-group-common/printer";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const toteBarcodeFormatSchema = createEnum([
  "individual",
  "sheet",
  "sheet-individual",
  "1x3",
  "1x4",
  "4x6",
]);

export const printToteBarcodes = {
  name: "printToteBarcodes" as const,
  input: z.object({
    toteIds: z.array(z.string()),
    format: toteBarcodeFormatSchema.optional(),
    printerId: z.number().optional(),
    printerOptions: PrinterOptionsSchema.optional(),
    idempotencyKey: z.string().optional(),
  }),
  output: z.object({ url: z.string() }),
};

export type PrintToteBarcodesInput = z.infer<typeof printToteBarcodes.input>;
